import { NavBar ,Footer} from "./Components";
import { Outlet } from "react-router-dom";

const Layout = () => {
    return (
        <div>
            <NavBar />
            <main>
                <Outlet /> {/* This will render your nested routes (Home, etc.) */}
            </main>
        <Footer />
        </div>
    );
};

export default Layout;